import { SystemFileId, SystemFileResponse } from '@business/entities/system_files/SystemFileResponse';
import { OrgId } from '@business/entities/organization';
import { FolderId } from '@business/entities/file';
import { Endpoint } from '../endpoint';
import { R } from '@core/utils/r';

export function fetchSystemFiles(status: number = 1) {
  const params = R.objectCompact({ status });

  return Endpoint.get<SystemFileResponse[]>(`@gc/system-files`, { params });
}

export function fetchSystemFile(id: SystemFileId) {
  return Endpoint.get<SystemFileResponse>(`@gc/system-files/file/${id}`);
}

export function createSystemFile(type: string) {
  return Endpoint.post<SystemFileResponse>(`@gc/system-files`, { data: { type } });
}

export function updateSystemFile(id: SystemFileId, data: Partial<SystemFileResponse>) {
  return Endpoint.patch<SystemFileResponse>(`@gc/system-files/${id}`, { data });
}

export function deleteSystemFile(id: SystemFileId) {
  return Endpoint.delete<void>(`@gc/system-files/${id}`);
}

export function uploadSystemFile(file: FormData) {
  return Endpoint.post<SystemFileResponse>(`@gc/system-files/file`, { data: file });
}

export function archiveSystemFile(id: SystemFileId) {
  return Endpoint.delete<void>(`@gc/system-files/${id}`);
}

export function restoreSystemFile(id: SystemFileId) {
  return Endpoint.post<void>(`@gc/system-files/restore/${id}`);
}

export function sortSystemFiles(ids: SystemFileId[]) {
  return Endpoint.post<void>(`@gc/system-files/sort`, { data: { ids } });
}

export function attachSystemFilesToFolder(orgId: OrgId, folderId: FolderId, systemFileIds: SystemFileId[]) {
  return Endpoint.post<void>(`@gc/organizations/${orgId}/folders/${folderId}/attach-system-files`, {
    data: { systemFileIds },
  });
}
